import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context/src/app-context';
import { IconHomeDelivery } from '@prisjakt/ui/icon';
import { Tooltip, TooltipPlacement } from 'src/components/tooltip-new';
import * as S from './styles';

export const HomeDeliveryBadge: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<unknown>
>> = () => {
  const { t } = useAppContext();

  return (
    <S.PriceInfoElement>
      <Tooltip
        placement={TooltipPlacement.TOP}
        title={t('product', 'home-delivery.info')}
        renderOnMouseOver
      >
        <S.IconWrapper>
          <IconHomeDelivery color="base400" />
        </S.IconWrapper>
      </Tooltip>
    </S.PriceInfoElement>
  );
};
